export class WaitingListCodeMinDTO {
    inscriptionId:number;
    accessCode:string;
}
